import { X } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import styles from './PanelHeader.module.scss';

type PanelHeaderProps = {
  onClose: () => void;
  title: string;
};

export const PanelHeader = ({ onClose, title }: PanelHeaderProps) => {
  return (
    <div className={styles.backButtonRow}>
      <button type="button" onClick={onClose} className={styles.backButton}>
        <span>{title}</span>
        <X size={SVG_SIZE_M} />
      </button>
    </div>
  );
};
